(() => {
  const SELECTOR = "slideshow-component.is-fade";

  function init(component) {
    if (component.dataset.crossfadeInit === "1") return;
    component.dataset.crossfadeInit = "1";

    const slider = component.querySelector("#Slider-" + component.closest("section")?.id?.replace("shopify-section-", "") ) 
      || component.querySelector(".slideshow.slider")
      || component.querySelector(".slideshow");

    const slides = Array.from(component.querySelectorAll(".slideshow .slider__slide"));
    if (!slider || slides.length <= 1) return;

    let index = 0;

    // まず1枚目を必ず表示
    slides.forEach((s, i) => {
      const active = i === 0;
      s.classList.toggle("is-fade-active", active);
      s.setAttribute("aria-hidden", active ? "false" : "true");
    });

    const apply = (i) => {
      index = (i + slides.length) % slides.length;
      slides.forEach((s, n) => {
        const active = n === index;
        s.classList.toggle("is-fade-active", active);
        s.setAttribute("aria-hidden", active ? "false" : "true");
      });

      const current = component.querySelector(".slider-counter--current");
      if (current) current.textContent = String(index + 1);

      const dots = Array.from(component.querySelectorAll(".slider-counter__link"));
      dots.forEach((b, n) => b.setAttribute("aria-current", n === index ? "true" : "false"));
    };

    // Dawn既存のクリックを奪う（capture）
    const hijack = (el, fn) => {
      if (!el) return;
      el.addEventListener(
        "click",
        (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          fn();
        },
        true
      );
    };

    hijack(component.querySelector(".slider-button--next"), () => apply(index + 1));
    hijack(component.querySelector(".slider-button--prev"), () => apply(index - 1));

    const dotBtns = Array.from(component.querySelectorAll(".slider-counter__link"));
    dotBtns.forEach((btn, n) => hijack(btn, () => apply(n)));

    // 自前オートプレイ
    const autoplayEl = component.querySelector(".slideshow.slider");
    const autoplay = autoplayEl?.dataset.autoplay === "true";
    const speedSec = Number(autoplayEl?.dataset.speed || 5);

    if (autoplay) {
      let timer = setInterval(() => apply(index + 1), Math.max(1500, speedSec * 1000));

      const stop = () => { if (timer) clearInterval(timer); timer = null; };
      const start = () => { stop(); timer = setInterval(() => apply(index + 1), Math.max(1500, speedSec * 1000)); };

      component.addEventListener("mouseenter", stop);
      component.addEventListener("mouseleave", start);
      component.addEventListener("focusin", stop);
      component.addEventListener("focusout", start);
    }
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(SELECTOR).forEach(init);
  });
})();
